// Features Section - Key features with icons and benefit-oriented copy
import { Search, Shield, Cloud } from "lucide-react"
import Settings from "../assets/settings.png"

const Benefits = () => {
  const features = [
    {
      icon: Search,
      title: "Unified Search",
      description: "Search local Mac files and Google Drive from one place. No more switching between Finder and browser tabs - everything you need, instantly accessible.",
      color: "green"
    },
    // {
    //   icon: Zap,
    //   title: "Lightning Fast",
    //   description: "Built natively for macOS with Spotlight-style speed. Results appear as you type, with zero lag or delay. Your workflow stays uninterrupted.",
    //   color: "amber"
    // },
    {
      icon: Cloud,
      title: "Cloud Integration",
      description: "Seamlessly search Google Drive alongside your local files. All your documents, spreadsheets, and presentations in one unified interface.",
      color: "purple"
    },
    // {
    //   icon: Shield,
    //   title: "Privacy First",
    //   description: "All indexing happens locally on your Mac. We never access, store, or upload your files. Your data stays yours, always.",
    //   color: "green"
    // }
  ];

  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 bg-white">
      {/* Section Header */}
      <div className="text-center mb-16">
        <h2 className="text-4xl sm:text-4xl font-semibold text-gray-900 mb-4">
          Everything you need in one search
        </h2>
        <p className="text-xl text-gray-600 max-w-3xl mx-auto">
          A search experience designed for speed, clarity, and zero friction across your entire digital life.
        </p>
      </div>

      {/* Features Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
        {features.map((feature, index) => {
          const Icon = feature.icon;
          const colorClasses = {
            blue: "bg-blue-100 text-blue-600",
            amber: "bg-amber-100 text-amber-600",
            purple: "bg-purple-100 text-purple-600",
            green: "bg-green-100 text-green-600"
          };

          return (
            <div 
              key={index}
              className="bg-white rounded-2xl p-8 border border-gray-200 hover:border-gray-300 hover:shadow-lg transition-all duration-300"
            >
              <div className={`w-14 h-14 ${colorClasses[feature.color as keyof typeof colorClasses]} rounded-xl flex items-center justify-center mb-6`}>
                <Icon className="w-7 h-7" />
              </div>
              <h3 className="text-2xl font-semibold text-gray-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          );
        })}
      </div>

      {/* Privacy Highlight Card */}
      <div className="bg-gradient-to-br from-blue-600 to-blue-700 rounded-2xl p-8 md:p-12 shadow-xl overflow-hidden relative">
        <div className="grid md:grid-cols-2 gap-8 items-center relative z-10">
          <div>
            <div className="w-14 h-14 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center mb-6">
              <Shield className="w-7 h-7 text-white" />
            </div>
            <h3 className="text-2xl font-semibold text-white mb-4">
              Privacy is non-negotiable
            </h3>
            <p className="text-blue-50 leading-relaxed mb-6">
              All indexing happens locally on your Mac. We never access, store, or upload your sensitive files. 
              Security is built in, not bolted on.
            </p>
            <div className="flex flex-wrap gap-3">
              <span className="bg-white/20 backdrop-blur-sm text-white px-4 py-2 rounded-full text-sm font-medium">
                Local-first architecture
              </span>
              <span className="bg-white/20 backdrop-blur-sm text-white px-4 py-2 rounded-full text-sm font-medium">
                Zero data collection
              </span>
            </div>
          </div>
          <div className="flex items-center justify-center md:justify-end">
            <img
              src={Settings}
              alt="Privacy settings panel"
              className="rounded-xl shadow-2xl max-w-full h-auto"
            />
          </div>
        </div>
        {/* Decorative gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-br from-blue-800/20 to-transparent pointer-events-none"></div>
      </div>
    </section>
  );
};

export default Benefits;
